/* eslint-disable lines-around-comment */
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "tss-react/mui";
import { createToolbarEvent } from "../../../analytics/AnalyticsEvents";
import { sendAnalytics } from "../../../analytics/functions";
import Popover from "../../../base/popover/components/Popover.web";
// @ts-ignore
import { ReactionEmoji, ReactionsMenu } from "../../../reactions/components";
import { REACTIONS_MENU_HEIGHT } from "../../../reactions/constants";
import { getReactionsQueue } from "../../../reactions/functions.any";
import { DRAWER_MAX_HEIGHT } from "../../constants";
// @ts-ignore
import Drawer from "./Drawer";
// @ts-ignore
import JitsiPortal from "./JitsiPortal";
// @ts-ignore
import OverflowToggleButton from "./OverflowToggleButton";
const useStyles = makeStyles()(() => {
    return {
        overflowMenuDrawer: {
            overflowY: "auto",
            height: `calc(${DRAWER_MAX_HEIGHT} - ${REACTIONS_MENU_HEIGHT}px - 16px)`,
        },
    };
});
const OverflowMenuButton = ({ children, isOpen, onVisibilityChange, showMobileReactions, }) => {
    const { classes } = useStyles();
    const overflowDrawer = useSelector((state) => state["features/toolbox"].overflowDrawer);
    const reactionsQueue = useSelector(getReactionsQueue);
    const onCloseDialog = useCallback(() => {
        onVisibilityChange(false);
    }, [onVisibilityChange]);
    const onOpenDialog = useCallback(() => {
        onVisibilityChange(true);
    }, [onVisibilityChange]);
    const onEscClick = useCallback((event) => {
        if (event.key === "Escape" && isOpen) {
            event.preventDefault();
            event.stopPropagation();
            onCloseDialog();
        }
    }, [onCloseDialog]);
    const toggleDialogVisibility = useCallback(() => {
        sendAnalytics(createToolbarEvent("overflow"));
        onVisibilityChange(!isOpen);
    }, [isOpen, onVisibilityChange]);
    //Open the more actions popover when  ArrowUp is pressed and move the focus to the last element of the popover menu
    const handleKeyDown = useCallback((event) => {
        if (event.key === "ArrowUp") {
            toggleDialogVisibility();
            const menuItems = document.querySelectorAll(".css-1x1dlre-contextMenuItem");
            if (menuItems.length > 0) {
                const lastMenuItem = menuItems[menuItems.length - 1];
                // @ts-ignore
                lastMenuItem.focus();
            }
        }
        //Access popover menu items and handle navigate over menu items using up and down arrow keys
        const popoverMenu = document.querySelector(".popover");
        if (popoverMenu) {
            const menuItems = popoverMenu.querySelectorAll(".css-1x1dlre-contextMenuItem");
            const moreActionsButton = document.querySelector(".toolbox-button[aria-label='More actions']");
            let selectedItemIndex = 0;
            // @ts-ignore
            popoverMenu.addEventListener("keydown", (e) => {
                // @ts-ignore
                if (e.key === "ArrowUp") {
                    e.preventDefault();
                    selectedItemIndex =
                        (selectedItemIndex - 1 + menuItems.length) %
                            menuItems.length;
                    // @ts-ignore
                    menuItems[selectedItemIndex].focus();
                    // @ts-ignore
                }
                else if (e.key === "ArrowDown") {
                    e.preventDefault();
                    selectedItemIndex = (selectedItemIndex + 1) % menuItems.length;
                    // @ts-ignore
                    menuItems[selectedItemIndex].focus();
                    // @ts-ignore
                }
                else if (e.key === "Escape") {
                    // @ts-ignore
                    moreActionsButton.focus();
                }
            });
        }
    }, []);
    return (React.createElement("div", { className: "toolbox-button-wth-dialog context-menu" }, overflowDrawer ? (React.createElement(React.Fragment, null,
        React.createElement(OverflowToggleButton, { handleClick: toggleDialogVisibility, isOpen: isOpen, onKeyDown: onEscClick }),
        React.createElement(JitsiPortal, null,
            React.createElement(Drawer, { isOpen: isOpen, onClose: onCloseDialog },
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: classes.overflowMenuDrawer }, children),
                    showMobileReactions && (React.createElement(ReactionsMenu, { overflowMenu: true })))),
            showMobileReactions && (React.createElement("div", { className: "reactions-animations-container" }, reactionsQueue.map(({ reaction, uid }, index) => (React.createElement(ReactionEmoji, { index: index, key: uid, reaction: reaction, uid: uid })))))))) : (React.createElement(Popover, { content: children, onPopoverClose: onCloseDialog, onPopoverOpen: onOpenDialog, position: "top", trigger: "click", visible: isOpen },
        React.createElement(OverflowToggleButton, { tabIndex: 0, isOpen: isOpen, onKeyDown: handleKeyDown })))));
};
export default OverflowMenuButton;
